<template name = "dateTemplate" lang="html">
	<div class="row">
		<b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>
		<div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
			<div class="sidebar-header">
				<h5>&nbsp;</h5>
				<a href="" id="sidebarMenuClose"><feather type="x" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather></a>
			</div><!-- df-sidebar-header -->
			<div class="sidebar-body">
				<div>
					<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms" v-if="form.name">
						<li class="nav-label mg-b-10-f">&nbsp;</li>
						<div class="form-group">
							<label class="has-text-weight-semibold">{{form.name}}</label>
							<input type="text" v-on:keyup="textKeyupEvent" class="form-control" v-model="form.value" :id="form.id" :placeholder="form.name">
						</div>
					</ul>

					<ul class="sidebar-nav" v-for="(form, i) in checkboxSearchForms">
						<div class="form-group">
							<label for="formGroupExampleInput" class=" d-block has-text-weight-semibold">{{form.name}}</label> 
							<div class="ml-2 custom-control custom-radio mb-1" v-for="(form1, i) in form.subs">
								<input type="radio" v-on:click="checkClickEvent" :id="form1.codeCode" :name="form.id" :value="form1.codeCode" v-model="form.value" class="custom-control-input">
								<label class="custom-control-label" :for="form1.codeCode">{{form1.codeName}}</label>
							</div>
						</div>
					</ul>
						<ul class="sidebar-nav mg-t-35-f" v-for="(form, i) in dateSearchForms">
					<li class="nav-label mg-b-10-f">Date Search</li>
					<label for="formGroupExampleInput" class="d-block">{{form.name}}</label>
					<li class="nav-item"><date-picker @dp-change="dateKeyupEvent" v-model="form.fvalue" :config="datePickerOptions" class="form-control" autocomplete='off' placeholder="From date" :id="form.fid" aria-label="Search" ignoreReadonly/></li>
					<li class="nav-item"><date-picker @dp-change="dateKeyupEvent" v-model="form.evalue" :config="datePickerOptions" class="form-control" autocomplete='off' placeholder="To date" :id="form.eid" aria-label="Search" ignoreReadonly/></li>
				</ul>
				</div>
			</div><!-- sidebar-body -->
		</div><!-- sidebar -->
		<div class="content content-components">
			<div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
				<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
					<div>
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb breadcrumb-style1 mg-b-10">
								<li class="breadcrumb-item">{{this.mainName}}</li>
								<li class="breadcrumb-item" aria-current="page">{{this.subName}}</li>
							</ol>
							<h4 class="mg-b-0 tx-spacing--1">{{this.subName}}</h4>
						</nav>
					</div>
				</div>
				<div class=" pd-x-0 pd-lg-x-10 pd-xl-x-0">
					<div class="col-sm-6 col-lg-5">
						<ul class="cardborder nav nav-tabs" id="myTab" role="tablist"> <!-- 상단 tab (현재단계 / 이전단계검체 / Plate) -->
							<li class="nav-item"><a class="nav-link active" id="wait-tab" data-toggle="tab" href="#waits" @click="createSearchForm(2, true)" role="tab" aria-controls="waits" aria-selected="false">Wait</a></li>
							<li class="nav-item"><a class="nav-link" id="analysis-tab" @click="classifyData(1, true)" data-toggle="tab" href="#analysis" role="tab" aria-controls="analysis" aria-selected="false">Task List</a></li>
						</ul>
					</div>
					<div class="card card-body">
						<div class="tab-content mg-t-20" id="myTabContent">
							<div class="tab-pane fade lm-overflow show active" id="waits" role="tabpanel" aria-labelledby="wait-tab">
								<div class="d-none d-webkit-box tx-right-f mg-xs-y-15-f" >
                                    <b-select
                                        placeholder="Select a Pipeline"
                                        v-model="selPipeline">
                                        <option v-for="option in pipelines" :value="option">
                                            {{ option.name }}
                                        </option>
                                    </b-select>
                                    <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" v-on:click="runDialogHandler()"><feather type="refresh-cw" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Run</button>
									<!--<a href="#modal6" class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="refresh-cw" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Run</a>-->

									<!-- <a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal" @click="addRun"><feather type="refresh-cw"  class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Run</a> -->
								</div>
								<section>
									<b-field grouped group-multiline>
										<b-select v-model="wPerPage" :disabled="!wIsPaginated">
										<option value="20">20</option>
										<option value="50">50</option>
										<option value="100">100</option>
										<option value="200">200</option>
										</b-select>
									</b-field>
								</section>
								<section>
                                    <b-table 
                                        id='preTable' 
                                        :data="isEmpty ? [] : preData" 
                                        :checked-rows.sync="waitCheckedRows"  
                                        :loading="loading" 
                                        paginated
                                        hoverable striped backend-pagination 
                                        checkable 
                                        :total="total" 
                                        :per-page="perPage" 
                                        @page-change="onPageChange" 
                                        aria-next-label="Next page" 
                                        aria-previous-label="Previous page" 
                                        aria-page-label="Page" 
                                        aria-current-label="Current page" 
                                        backend-sorting>
                                        <template slot-scope="props">
                                            <b-table-column v-for="(form, i) in preHeader" v-if="form.columnAttr == 'runid'" :key="i" :field="form.columnAttr" :label="form.columnName" centered sortable>
                                                <a href='#' @click='classifySample(props.row.id)'>{{ props.row[form.columnAttr] }}</a>
                                                <!-- <a href='#' @click='toggle(props.row)' :id="props.index"> {{ props.row[form.columnAttr] }} </a> -->
                                            </b-table-column>
                                            <b-table-column v-else :key="i" :field="form.columnAttr" :label="form.columnName" centered sortable>{{ props.row[form.columnAttr] }} </b-table-column>
                                        </template>
                                        <template slot="empty">
                                            <section class="section">
                                                <div class="content has-text-grey has-text-centered">
                                                    <p>Nothing here.</p>
                                                </div>
                                            </section>
                                        </template>
                                    </b-table>
								</section>
                                <div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
                                    <div class="row row-xs">
                                        <div class="col-lg-12 mg-t-10">
                                            <section>
                                                <ul id="myTab5" role="tablist" v-if="datacolumns.length > 0 " class="nav nav-line" style="padding-left: 10px;">
                                                    <li class="nav-item" v-for="(form, i) in preTabHeader" v-if="preMid === form.id"><a class="nav-link active" @click='classifySampleHeader(form.id,form.jobOrder)' :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="true">{{form.menuName}}</a></li>
                                                    <li class="nav-item" v-else-if="form.jobOrder != 6" ><a class="nav-link" @click='classifySampleHeader(form.id,form.jobOrder)' :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="profile" aria-selected="false">{{form.menuName}}</a></li>
                                                </ul>
                                                <div class="">
                                                    <div class="" style="white-space:nowrap; overflow-x:scroll;">
                                                        <b-table :data="items" hoverable striped paginated per-page="15">
                                                            <template slot-scope="props">
                                                                <b-table-column v-for="(form, i) in datacolumns" v-if="form.field == 'receptionno'" :key="i" :field="form.field" :label="form.label" centered sortable><a href='#modal52' data-toggle="modal" data-animation="effect-flip-horizontal" @click='sendId(props.row.receptionId)'> {{ props.row[form.field] }} </a></b-table-column>
                                                                <b-table-column v-else :key="i" :field="form.field" :label="form.label" centered sortable>{{ props.row[form.field] }}</b-table-column>
                                                            </template>
                                                        </b-table>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </div>    
							</div><!-- tab -->
							<div class="tab-pane fade" id="analysis" role="tabpanel" aria-labelledby="analysis-tab">
								 <section>
									<b-field grouped group-multiline>
										<b-select v-model="perPage" :disabled="!isPaginated">
										<option value="20">20</option>
										<option value="50">50</option>
										<option value="100">100</option>
										<option value="200">200</option>
										</b-select>
									</b-field>
								</section>
                                <section> 
									<b-table 
										id='preTable' 
										:data="isEmpty ? [] : aSampleData" 
										ref="table"
										hoverable paginated striped detailed
										backend-pagination
										:total="total"
										:per-page="perPage"
										@page-change="onPageChange"
										aria-next-label="Next page"
										aria-previous-label="Previous page"
										aria-page-label="Page"
										aria-current-label="Current page"
										backend-sorting
										detail-key="id" 
										:show-detail-icon="false" 
										:opened-detailed="defaultOpenedDetails" 
										@details-open="(row, index) => closeAllOtherToggle(row, index)" 
										@dblclick="(row, index) => doubleClickHandler(row, index)">
										<template slot-scope="props">
											<b-table-column v-for="(form, i) in nowHeader" v-if="Number(i) == 0" :key="form.id" :custom-key="form.id" field="no" :label="'No'" centered >{{props.row.no}}</b-table-column>
											<b-table-column v-else-if="Number(i) == 1" :key="form.id" :custom-key="form.id" :field="form.columnCode" :label="form.columnName" centered>
												<a href='#' @click='aToggle(props.row)' :id="props.index"> {{ props.row[form.columnCode] }} </a>
											</b-table-column>
											<b-table-column v-else :key="form.id" :custom-key="form.id" :field="form.columnCode" :label="form.columnName" centered>{{props.row[form.columnCode]}}</b-table-column>
										</template>
										<template slot="empty">
											<section class="section">
												<div class="content has-text-grey has-text-centered">
												<p>Nothing here.</p>
												</div>
											</section>
										</template>
											<template slot="detail" slot-scope="props">
                                                <ul class="nav nav-line" id="myTab5" role="tablist">
                                                    <li class="nav-item" v-for="(form, i) in tabHeader" v-if="i == 0">
                                                        <a class="nav-link" @click="classifyPreSampleHeader(form)" :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="true">{{form.menuName}}</a>
                                                    </li>
                                                    <li class="nav-item" v-else-if="(tabHeader.length - 2) > i">
                                                        <a class="nav-link" @click="classifyPreSampleHeader(form)" :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="false">{{form.menuName}}</a>
                                                    </li>
                                                    <li class="nav-item" v-else-if="(tabHeader.length - 2) == i">
                                                        <a class="nav-link active" @click="classifyPreSampleHeader(form)" :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="false">{{form.menuName}}</a>
                                                    </li>
                                                </ul>
											    <b-table id="preSampleTable" :columns="preSampleHeader" :data="isEmpty ? [] : aPreSampleData" ref="sampleTable" hoverable striped>
                                                    <template slot="empty">
                                                        <section class="section">
                                                            <div class="content has-text-grey has-text-centered">
                                                            <p>Nothing here.</p>
                                                            </div>
                                                        </section>
                                                    </template>
                                                </b-table>
											</template>
									    </b-table>
									<div class='d-none'><b-table id='preSampleTable' ref="sampleTable"></b-table></div>
								</section>
                                <section>
                                    <!-- <h5>Task Queue</h5> -->
                                    <b-field label="Task Queue">
                                        <b-taginput
                                            class="taginput-sortable"
                                            v-sortable="sortableOptions"
                                            size="is-large"
                                            v-model="tags"
                                            ellipsis
                                            >
                                        </b-taginput>
                                    </b-field>
                                </section>
							</div><!-- tab -->
						</div>
					</div><!-- card -->
				</div>
			</div>
		</div>
		<div class="modal fade" id="modal5" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel5" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered chat-width" role="document">
				<div class="modal-content tx-14 chat-height">
					<div class="modal-header">
					<h6 class="modal-title" id="exampleModalLabel5">Chat</h6>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
					</div>
					<div class="modal-body">
						<Chat></Chat>
					</div>
				</div>
			</div>
		</div><!-- chat modal -->


		 <div class="modal fade" id="modal6" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel6" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content tx-14">
          <div class="modal-header">
          <h6 class="modal-title" id="exampleModalLabel6">New Task</h6>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          </div>
          <div class="modal-body">
          <p class="mg-b-0">&nbsp;</p>
          <p class="mg-b-0">
			<div class="card">
				<div class="card-body">
					<div v-if="selPipeline.name">
						<h6><span class="badge badge-light">{{selPipeline.name}}</span></h6>
						<ul class="list-group" v-for="data in selPipeline.param">
							<li class="list-group-item d-flex justify-content-between align-items-center">
								{{data.key}}
								<!-- <b-tooltip :label="form.message"
									position="is-bottom"
									:animated="false">
									<input type="text" :id="'key'+i" :value="form.key" @change="chgParameter(i,'key',$event)" placeholder="key" class="form-control d-inline w-auto">
								</b-tooltip> -->
								<span class="badge badge-primary badge-pill">{{data.value}}</span>

							</li>
						</ul>
					</div>
					<div v-else>
						<h6><span class="badge badge-danger">please select a pipeline</span></h6>
					</div>
				</div>
				
				<div v-if="waitCheckedRows.length != 0" class="card-header">
					
				</div>
				<div v-if="waitCheckedRows.length == 1" class="card-header">
					<!-- <label v-if="waitCheckedRows.length != 0" class="has-text-weight-semibold">Serial</label> -->
					<div v-for="(row, index) in waitCheckedRows">
						<h6><span class="badge badge-light">Serial</span></h6>
						<input type="form-control" style="width:20rem;" class="form-control mb-1" v-model="row.runId">
						<h6><span class="badge badge-light">INPUT_PATH</span></h6>
						<input type="form-control" style="width:27rem;" class="form-control" v-model="row.path">
					</div>
				</div>

                <div v-else class="card-header">
                    <div>
						<h6><span class="badge badge-light">Serial</span></h6>
						<input type="form-control" style="width:20rem;" class="form-control mb-1">
						<h6><span class="badge badge-light">INPUT_PATH</span></h6>
						<input type="form-control" style="width:27rem;" class="form-control">
					</div>
                </div>
                
				<div v-else class="card-header">
					<h6><span class="badge badge-danger">please select a data</span></h6>
				</div>
				
			</div>
          </p>
          </div>
          <div class="modal-footer">
			<button type="button" class="btn btn-secondary tx-13" data-dismiss="modal">Close</button>
			<button type="button" class="btn btn-primary tx-13" @click="addRun" data-dismiss="modal">Run</button>
          </div>
        </div>
		</div>
    </div><!-- pipeline modal -->

		<div class="modal fade" id="modal7" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel7" aria-hidden="true">
			<div class="modal-dialog modal-xl" role="document">
				<div class="modal-content">
					<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLabel5">Task Info</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
					</div>
					<div class="modal-body">
						<Task></Task>
					</div>
				</div>
			</div>
		</div><!-- Task Info modal -->
		<v-app>
           <v-dialog
            v-model="dialog"
            hide-overlay
			
			max-width="600"
            transition="dialog-bottom-transition"
            scrollable
          >
            <v-card tile height="800px">
              <v-toolbar
                flat
                dark
                color="primary darken-1"
              >
                <v-btn
                  icon
                  dark
                  @click="dialog = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Pipeline Settings</v-toolbar-title>
                <v-spacer />
                <v-toolbar-items>
                  <v-btn
                    dark
                    text
                    @click="addRun()"
                  >
                    <v-icon>
                      mdi-desktop-mac-dashboard
                    </v-icon>
                    &nbsp;&nbsp;Run
                  </v-btn>
                </v-toolbar-items>
           
                <v-menu
                  bottom
                  right
                  offset-y
                />
              </v-toolbar>
              <v-card-text>
                <v-list
                  three-line
                  subheader
                >
                  <v-subheader>User Controls</v-subheader>
                  <v-form
                    ref="form"
                    lazy-validation
                  >
                    <!--<v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Company / Institution</v-list-item-title>
                        <v-text-field
                          ref="company"
                          v-model="company"
                          label="Company / Institution"
                          :rules="[rules.required, rules.blank]"
                          required
                        />
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Date Of Sample Reception</v-list-item-title>
                        <v-text-field
                          ref="receptionDate"
                          v-model="receptionDate"
                          label="Date Of Sample Reception"
                          :rules="[rules.required, rules.blank]"
                          required
                        />
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Target Region</v-list-item-title>
                        <v-text-field
                          ref="targetRegion"
                          v-model="targetRegion"
                          label="Target Region"
                          :rules="[rules.required, rules.blank]"
                          required
                        />
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Requested Read Count</v-list-item-title>
                        <v-text-field
                          ref="requestedRead"
                          v-model="requestedRead"
                          label="Requested Read Count"
                          :rules="[rules.required, rules.blank]"
                          required
                        />
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Rarefied Read Count</v-list-item-title>
                        <v-text-field
                          ref="rarefiedRead"
                          v-model="rarefiedRead"
                          label="Rarefied Read Count"
                          :rules="[rules.required, rules.blank]"
                          required
                        />
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Type of Sequencer</v-list-item-title>
                        <v-text-field
                          ref="sequencer"
                          v-model="sequencer"
                          label="Sequencer"
                          :rules="[rules.required]"
                          required
                        />
                      </v-list-item-content>
                    </v-list-item>-->
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Serial</v-list-item-title>
                        <v-text-field
                          ref="serial"
                          v-model="serial"
                          label="Serial"
                          :rules="[rules.required, rules.blank, rules.str]"
                          required
                        />
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Input Path</v-list-item-title>
                        <v-text-field
                          ref="inputPath"
                          v-model="inputPath"
                          label="Input Path"
                          :rules="[rules.required, rules.blank]"
                          required
                        />
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Database</v-list-item-title>
                        <v-select
                          ref="database"
                          v-model="database"
                          :items="databaseOptions"
                          :rules="[rules.required]"
                        />
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>% Identity</v-list-item-title>
                        <v-select
                          ref="identity"
                          v-model="identity"
                          :items="identityOptions"
                          :rules="[rules.required]"
                          label="The value of Representative identity in Reference DB"
                        />
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>TRIM_FWD</v-list-item-title>
                        <v-text-field
                          ref="trim_fwd"
                          v-model="trim_fwd"
                          label="The value to trim the length of forward reads of R1 fastq"
                          :rules="[rules.required]"
                          required
                        />
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>TRIM_REV</v-list-item-title>
                        <v-text-field
                          ref="trim_rev"
                          v-model="trim_rev"
                          label="The value to trim the length of reverse reads of R2 fastq"
                          :rules="[rules.required]"
                          required
                        />
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>TRIM_MERGED</v-list-item-title>
                        <v-text-field
                          ref="trim_merged"
                          v-model="trim_merged"
                          label="The value to trim the length of merged reads"
                          :rules="[rules.required]"
                          required
                        />
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>METHOD</v-list-item-title>
                          <v-select
                          ref="method"
                          v-model="method"
                          :items="methodOptions"
                          :rules="[rules.required]"
                        />
                      </v-list-item-content>
                    </v-list-item>
                  
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>READ_DEPTH</v-list-item-title>
                        <!--<v-slider
                          v-model="read_depth"
                          class="mt-13"
                          hint="Im a hint"
                          max="100000"
                          min="1000"
                          prepend-icon="mdi-minus"
                          append-icon="mdi-plus"
                          thumb-label="always"
                          :thumb-size="50"
                          step="1000"
                          ticks="always"
                          :rules="readDepthRules"
                          @click:append="zoomIn"
                          @click:prepend="zoomOut"
                        />-->
						<v-text-field
                          ref="read_depth"
                          v-model="read_depth"
                          label="The value to filter the Read Depth(if value is 20000, filtering under 20000)"
                        />
                      </v-list-item-content>
                    </v-list-item>
                    <!-- <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>REMOVE_MT_CP</v-list-item-title>
						<v-radio-group
							ref="remove_mt"
							v-model="remove_mt"
							inline
							label="remove the mictochondria and chlorophlast in taxonomy profile"
						>
							<v-radio
								label="Y"
								value="Y"
							></v-radio>
							<v-radio
								label="N"
								value="N"
							></v-radio>
						</v-radio-group>
						
                      </v-list-item-content>
                    </v-list-item> -->
                  </v-form>
                </v-list>
              </v-card-text>

              <div style="flex: 1 1 auto;" />
            </v-card>
          </v-dialog>
		</v-app>
		<v-app>
           <v-dialog
            v-model="dialogShell"
            hide-overlay
			
			max-width="600"
            transition="dialog-bottom-transition"
            scrollable
          >
            <v-card tile height="800px">
              <v-toolbar
                flat
                dark
                color="primary darken-1"
              >
                <v-btn
                  icon
                  dark
                  @click="dialogShell = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Pipeline Settings</v-toolbar-title>
                <v-spacer />
                <v-toolbar-items>
                  <v-btn
                    dark
                    text
                    @click="addRun()"
                  >
                    <v-icon>
                      mdi-desktop-mac-dashboard
                    </v-icon>
                    &nbsp;&nbsp;Run
                  </v-btn>
                </v-toolbar-items>
           
                <v-menu
                  bottom
                  right
                  offset-y
                />
              </v-toolbar>
              <v-card-text>
                <v-list
                  three-line
                  subheader
                >
                  <v-subheader>User Controls</v-subheader>
                  <v-form
                    ref="form"
                    lazy-validation
                  >
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Serial</v-list-item-title>
                        <v-text-field
                          ref="serial"
                          v-model="serial"
                          label="Serial"
                          :rules="[rules.required, rules.blank]"
                          required
                        />
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Input Path</v-list-item-title>
                        <v-text-field
                          ref="inputPath"
                          v-model="inputPath"
                          label="Input Path"
                          :rules="[rules.required, rules.blank]"
                          required
                        />
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Database</v-list-item-title>
                        <v-select
                          ref="database"
                          v-model="database"
                          :items="databaseOptions"
                          :rules="[rules.required]"
                        />
                      </v-list-item-content>
                    </v-list-item>

					<v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>MIN_DEPTH</v-list-item-title>
						<v-text-field
                          ref="min_depth"
                          v-model="min_depth"
                          label="Minimum depth of samples to use for analysis, If the values is 0, depth would be automatically set."
                        />
                      </v-list-item-content>
                    </v-list-item>

					<v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>MAX_DEPTH</v-list-item-title>
						<v-text-field
                          ref="max_depth"
                          v-model="max_depth"
                          label="Maximum depth of samples to use for analysis, If the values is 0, depth would be automatically set."
                        />
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>GROUP</v-list-item-title>
                        <v-select
                          ref="group"
                          v-model="group"
                          :items="groupOptions"
                          :rules="[rules.required]"
                          label="OPTION: single, common or group"
                        />
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>REGION</v-list-item-title>
                        <v-select
                          ref="region"
                          v-model="region"
                          :items="regionOptions"
                          :rules="[rules.required]"
                          label="OPTION: v3v4,v4 or its"
                        />
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>TYPE</v-list-item-title>
                        <v-select
                          ref="type"
                          v-model="type"
                          :items="typeOptions"
                          :rules="[rules.required]"
                          label='FASTQ TYPE, default is "paired". specify "single" if you use single-end or merged fastq'
                        />
                      </v-list-item-content>
                    </v-list-item>
					<v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>REMOVE_MT_CP</v-list-item-title>
						<v-radio-group
							ref="remove_mt"
							v-model="remove_mt"
							inline
							label="remove the mictochondria and chlorophlast in taxonomy profile"
						>
							<v-radio
								label="Y"
								value="Y"
							></v-radio>
							<v-radio
								label="N"
								value="N"
							></v-radio>
						</v-radio-group>
						
                      </v-list-item-content>
                    </v-list-item>
                  </v-form>
                </v-list>
              </v-card-text>

              <div style="flex: 1 1 auto;" />
            </v-card>
          </v-dialog>
		</v-app>
	</div> <!-- this body end -->
	
</template>
<script>
	// 공통 함수 관리 파일 임포트
	import common from '@/views/Common/common.js';
	import datePicker from "vue-bootstrap-datetimepicker";
	import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
    import draggable from "vuedraggable";
	// 멀티 드래그 앤 드롭 임포트
	import Sortable, {Swap} from 'sortablejs';
	Sortable.mount(new Swap());

    const createSortable = (el, options, vnode) => {
        return Sortable.create(el, {
            ...options,
            onEnd: function (evt) {
                const data = vnode.componentInstance.$data.tags
                const item = data[evt.oldIndex]
                if (evt.newIndex > evt.oldIndex) {
                    for (let i = evt.oldIndex; i < evt.newIndex; i++) {
                        data[i] = data[i + 1]
                    }
                } else {
                    for (let i = evt.oldIndex; i > evt.newIndex; i--) {
                        data[i] = data[i - 1]
                    }
                }
                data[evt.newIndex] = item
                vnode.componentInstance.$emit('input', data)
                vnode.context.$buefy.toast.open(`Moved ${item} from row ${evt.oldIndex + 1} to ${evt.newIndex + 1}`)
            }
        })
    }

    const sortable = {
        name: 'sortable',
        bind(el, binding, vnode) {
            const container = el.querySelector('.taginput-container')
            container._sortable = createSortable(container, binding.value, vnode)
        },
        update(el, binding, vnode) {
            const container = el.querySelector('.taginput-container')
            container._sortable.destroy()
            container._sortable = createSortable(container, binding.value, vnode)
        },
        unbind(el) {
            const container = el.querySelector('.taginput-container')
            container._sortable.destroy()
        }
    }
    
	// Header의 메뉴 정보 호출을 위한 bus event
	import {bus} from '../../../main';
	import Chat from "@/views/Common/Chat";
	import Task from "@/views/Common/TaskInfo";

	import moment from "moment";
	export default {
		name: 'Detail',
		props: ['properties'],
		directives: { sortable },
		data(){
			return{
				//run dialog
				dialogShell: false,
				dialog: false,
				sampleData: [],
				selectCount: 0,

				//Analysis Params
				company: '',
				receptionDate: '',
				targetRegion: '',
				requestedRead: '20000',
				rarefiedRead: '20000',
				sequencer: 'Illusmina MiSeq',
				analysisName: '',
				serial: '',
				inputPath: '',
				databaseOptions: ['silva', 'gg', 'unite'],
				database: '',
				identityOptions: ['97', '99'],
				identity: '',
				trim_fwd: '',
				trim_rev: '',
				trim_merged: '',
				method: '',
				methodOptions: ['rdp', 'uclust'],
				min_depth: '0',
				max_depth: '0',
				group: '',
				groupOptions: ['single', 'common', 'group'],
				region: '',
				regionOptions: ['v3v4', 'v4', 'its'],
				type: 'paired',
				typeOptions: ['paired', 'single'],

				// targetRegion1Options: ['16S', '18S', 'ITS'],
				// targetRegion1: '',
				// targetRegion2: '',
				remove_mt: 'N',
				read_depth: 20000,
				readDepthRules: [
				v => v >= 10000 || `It's too low.`,
				],
				rules: {
					required: v => !!v || 'This field is required',
					blank: v => !(/[ ]/.test(v)) || 'no spaces allowed',
					str: v => (/^[a-zA-Z0-9_]*$/.test(v)) || 'Enter numbers, alphabets, underbar only',
				},

                sortableOptions: {
                    chosenClass: 'is-primary',
                    draggable: '.tag'
                },
                tags: [],
				mainName:'',
				subName:'',
				menuData:[], // header.vue data
                pipelines : [],
                selPipeline:{},
				mid:'', // menu list id
				msid:'', // menu sheet id
				uid:'', // sheet id
				ssid:'', // sample list id
				rowNum:'', // sample group row number
				re_expid: '',

				/* Experiment input Form */
				experimentHeader:[], // 입력 값 header column
				inputSearchForms:[], // 입력 input form
				dateSearchForms:[], // 입력 date form
				checkboxSearchForms:[], // 입력 radio form

				/* Experiment 정보 Form Value */
				experimentData: [], // 실험 정보 확인
				defaultExperimentData: [], // 화면에 처음 접속 시 유지된 실험 정보 (데이터 저장 시 수정 사항 체크에 필요)

				/* tab Header */
				tabHeader:[],
                preTabHeader:[],
				// sheetCoulumns:[],

				/* 이전 단계 Sample 정보 */
				preHeader:[],
				preData:[],
				preDefaultData:[],
				preSampleHeader:[],
				preSampleData:[],
				preDefaultSampleData:[],
				preDetail:[],
				waitCheckedRows:[],
				checkedRows:[], // 그룹 체크 row 확인
				analysisCheckedRows:[],
				checkedRowData:[], // add 이전 체크 sample row 확인
				sampleCheckedRows:[], // sample 체크 row 확인
				isEmpty: false,
				addData:[],
				defaultOpenedDetails:[],
                //현재 단계
                nowHeader:[],
                
				/* 데이터 변경 여부 sample add 등 Handsontable에 행위가 없어도 저장할 수 있도록 */
				isWork: 0,

				/* Sample Form */
				sampleHeader:[], // Experiment Sample Header
                sampleData:[], // Experiment Sample list data
                // sampleData:[
                //     {'no' : '1', "C00002" : "SR-2001-0001"}
                // ],
				// sampleData:[1,2,3,4,5,6,7,8,9,10],
				
				dafaultSampleData:[], // 화면에 처음 접속 시 유지된 Sample 정보 (데이터 저장 시 수정 사항 체크에 필요)
				sampleChangeData:[], // Sample의 변경 정보
				boolChange: false, // 데이터 변경 유무 확인
				preDetail:[],


				/* Loading */
				isLoading: false,
				isFullPage: true,

				isCheckAll: false,

				//analysis list
				isPaginated: true,
				total: 0,
				loading: false,
				sortField: "",
				sortOrder: "",
				page: 1,
				perPage: 200,

				//wait list
				wIsPaginated: true,
				wTotal: 0,
				wLoading: false,
				wSortField: "",
				wSortOrder: "",
				wPage: 1,
				wPerPage: 200,

				excelHeader:{},
				excelData:[],
                json_meta: [[{'key': 'charset','value': 'utf-8'}]],
                
                /* Analysis tab Data */
                aSampleData: [],
                aPreDefaultSampleData: [],
                aPreSampleData:[],
                aRowNum:'',
				serialNumber:'',
				rowTaskData:{},
				presentTab:'',
				rowData:{},

				reTaskPipeLine:[],

				datePickerOptions: {
					format: "YYYY-MM-DD",
					useCurrent: false,
					showTodayButton: true,
					keepInvalid: false,
					ignoreReadonly: true
				},
				toDay:new Date(new Date().setDate(new Date().getDate())).toISOString().slice(0,10),
				yesterDay:new Date(new Date().setDate(new Date().getDate()-1)).toISOString().slice(0,10),
				tabFlag:2,

                datacolumns : [],
                items : [],
                preMid : ''

			}
		},
		beforeDestroy(){
			bus.$off('menu_data')
		},
		created(){
			this.openLoading();
			bus.$on('menu_data', (data)=>{
				this.menuData = data;
				this.classifyHeader();
				this.classifyPreDefaultData(true);
			});
			this.getPipeLines();
		},
		mounted() {
		},
		components: {
			moment,
			Chat,
			Task,
			datePicker,

		},
		methods: {
			searchHandler() {
				if (this.tabFlag == 2) {

				} else {

				}
			},
			/*
			* keyup search
			*/
			textKeyupEvent() {
				if (this.tabFlag == 2) {
					this.classifyPreDefaultData(false);
				} else {
					this.classifyData(this.tabFlag, false);
				}
				return false;
			},
			dateKeyupEvent(e) {
				if (e.oldDate != null) {
					if (this.tabFlag == 2) {
						this.classifyPreDefaultData(false);
					} else {
						this.classifyData(this.tabFlag, false);
					}
				}
				return false;
			},
			checkClickEvent(e) {
				if (this.tabFlag == 2) {
						this.classifyPreDefaultData(false);
				} else {
					this.classifyData(this.tabFlag, false);
				}
				return false;
			},
			createSearchForm(tab, initial) {
				if (initial) {
					this.tabFlag = tab;

					this.inputSearchForms = [];
					this.inputCompanyForms = [];
					this.dateSearchForms = [];
					this.checkboxSearchForms = [];
					if (tab < 2) { //analysis
						for (let i in this.nowHeader) {
							if (this.nowHeader[i].columnType == "LIST") {
								this.checkboxSearchForms.push({name: this.nowHeader[i].columnName,value: [],subs: this.nowHeader[i].code,id: this.nowHeader[i].columnCode, attr:this.nowHeader[i].columnAttr});
							} else if (this.nowHeader[i].columnType == "DATE") {
								this.dateSearchForms.push({name: this.nowHeader[i].columnName,id: this.nowHeader[i].columnCode,fid: "f_" + this.nowHeader[i].columnAttr,eid: "e_" + this.nowHeader[i].columnAttr, attr:this.nowHeader[i].columnAttr});
							} else {
								if (this.nowHeader[i].columnName != "No") {
									this.inputSearchForms.push({name: this.nowHeader[i].columnName,value: "",id: this.nowHeader[i].columnCode, attr:this.nowHeader[i].columnAttr});
								}
							}
						}
					} else { //wait
						for (let i in this.preHeader) {
							if (this.preHeader[i].columnType == "LIST") {
								this.checkboxSearchForms.push({name: this.preHeader[i].columnName,value: [],subs: this.preHeader[i].code,id: this.preHeader[i].columnCode, attr:this.preHeader[i].columnAttr});
							} else if (this.preHeader[i].columnType == "DATE") {
								this.dateSearchForms.push({name: this.preHeader[i].columnName,id: this.preHeader[i].columnCode, attr:this.preHeader[i].columnAttr, fvalue: this.yesterDay,evalue: this.toDay,fid: "f_" + this.preHeader[i].columnAttr,eid: "e_" + this.preHeader[i].columnAttr});
							} else {
								if (this.preHeader[i].columnName != "No") {
									this.inputSearchForms.push({name: this.preHeader[i].columnName,value: "",id: this.preHeader[i].columnCode, attr:this.preHeader[i].columnAttr});
								}
							}
						}
					}
				}
				return false;
			},
			async doubleClickHandler(row, index) {
				this.rowData = row;
				this.rowTaskData = {};
				let task = {
					serial: row.serial,
					analysisNo: row.analysisNo,
					startTime: row.startTime,
					completeTime: row.completeTime,
					param: row.argument,
					stateCode: row.stateCode,
					output: row.output,
					error: row.error,
					progress: row.progress,
					message: row.state,
					path: row.inputPath,
					prev: row.prev,
				}
				this.reTaskPipeLine = row.pipeline

				this.rowTaskData = task;
				for (let i in this.experimentHeader) {
					if (this.experimentHeader[i].columnAttr == 'statecode') {
						for (let j in this.experimentHeader[i].code) {
							if (row.stateCode == this.experimentHeader[i].code[j].codeCode) {
								task.stateCode = this.experimentHeader[i].code[j].codeName;
								if (this.experimentHeader[i].code[j].codeName == 'Fail') {
									task.outputFlag = false;
								} else {
									task.outputFlag = true;
								}
							}
						}
					}
				}

				$('#modal7').modal('show');

				return false;
			},
			async getPipeLines() {
				const pipeLines = await this.$axios.get(this.$apiHost + '/pipelines/list');
				this.pipelines = pipeLines.data;
				return false;
			},
			async classifyHeader(){
				let data = common.menuHeader(this.properties.mid, this.menuData);
				this.mainName = data[0];
				this.subName = data[1];
				this.msid = data[2];
				this.experimentHeader = data[3];
                this.tabHeader = common.tabOrder(this.properties.mid, this.menuData);
                this.preMid = common.preMid(this.properties.mid, this.menuData);
                this.preTabHeader = common.tabOrder(this.preMid, this.menuData);
				this.nowHeader = common.menuHeader(this.properties.mid, this.menuData)[3];

				return false;
			},
			/*
			* Load Headers & Samples Data
			*/
			async classifyData(tabFlag, initial){
				this.aSampleData = [];
				this.aPreDefaultSampleData = [];
				this.tabFlag = tabFlag;
				this.presentTab = tabFlag;
				if (initial) {
					this.createSearchForm(tabFlag, initial);
				}
				let params = {};
				params = {
					flag: tabFlag
				}

				// input type
				for (let i in this.inputSearchForms) {
					if (this.inputSearchForms[i].value) params[this.inputSearchForms[i].id] = this.inputSearchForms[i].value;
				}
				// date type
				for (let i in this.dateSearchForms) {
					if (this.dateSearchForms[i].fvalue || this.dateSearchForms[i].evalue) {
						params[this.dateSearchForms[i].id] = this.dateSearchForms[i].fvalue +","+this.dateSearchForms[i].evalue;
					}
				}
				// check box type
				for (let i in this.checkboxSearchForms) {
					let inputKey = this.checkboxSearchForms[i].id;
					let checkValueStr = [];
					for (let j in this.checkboxSearchForms[i].subs) {
						let checkid = this.checkboxSearchForms[i].subs[j].codeCode;
						if ($("#" + checkid).is(":checked")) {
							checkValueStr[i] =
							checkValueStr.length > 0 ? checkValueStr[i].concat(",", $("#" + checkid).val()) : $("#" + checkid).val();
						}
					}
					if (checkValueStr[i]) params[inputKey] = checkValueStr[i];
				}

				let request = { params: params };
                await this.$axios.get(this.$apiHost + '/micro/detail', request).then(res=>{
					this.aSampleData = [];
					this.aPreDefaultSampleData = [];
                    for(let i in res.data){
                        res.data[i]['no'] = Number(i) + 1
                        this.aSampleData.push(res.data[i])
                        if(res.data[i].samples.length > 0){
						    this.aPreDefaultSampleData.push(res.data[i].samples);
                        }
					}
					let currentTotal = res.data.length;
					if (res.data.length / this.perPage > 100) {
						currentTotal = this.perPage * 100;
					}
					this.total = currentTotal;
                }).catch(err=>{console.log(err)});

                // await this.$axios.get(this.$apiHost + '/micro/getqueue').then(res=>{
                //     for(let i in res.data){
                //         this.tags.push(res.data[i].serial)
                //     }
                // }).catch(err=>{console.log(err)});
                
                
                // this.classifySampleHeader();
            },
        async classifySample(rid) {
            this.isLoading = true;
            this.rid = rid;
            let col = {};
            let row = [];
            let detailData = {};
            let mid = this.preMid

            if (this.datacolumns.length > 0) this.datacolumns.splice(0);
            if (this.items.length > 0) this.items.splice(0);

            await this.$axios.get(this.$apiHost + "/demultis"  + "/detail", {
                params: { menuId : mid ,runId: rid }
            }).then(res => {
                
                detailData = res.data;
            }).catch(error => {
                throw error;
            });
            this.items = detailData
           

            let detailCol = common.menuHeader(mid, this.menuData, 2);
            this.datacolumns.push({ field: "no", label: 'No' });
            this.datacolumns.push({ field: "receptionno", label: 'Reception No' });
            this.datacolumns.push({ field: "name", label: 'Sample No' });
            this.datacolumns.push({ field: "report", label: 'Report' });
            this.datacolumns.push({ field: "barcode", label: 'Barcode' });

            for(let i in detailCol[3]){
                this.datacolumns.push({field: detailCol[3][i].columnAttr, label: detailCol[3][i].columnName})
            }   
            

            this.isLoading = false;
        },
        async classifySampleHeader(mid,jobOrder) {
            this.datacolumns = [];
            if (this.datacolumns.length > 0) this.datacolumns.splice(0);
            if (this.items.length > 0) this.items.splice(0);

            let datacolumns = [];
            let thisMid = common.isNull(event.target.id) ? this.properties.mid : event.target.id;
            let premid = common.preMid(this.properties.mid, this.menuData);
            let preCol = common.AllHeader(premid, this.menuData, 1);

            // if (thisMid == this.properties.mid) {
            //     this.classifySample(this.rid)
            //     return false;
            // }

            // datacolumns = preCol[1];
            
            let detailColumns = []
            let headerColumns = []
            if(jobOrder == 7){
                this.classifySample(this.rid)
                return false;
            }else{
                this.datacolumns.push({ field: "no", label: 'No' });
                if(jobOrder == 1){
                    detailColumns = common.menuHeader(mid, this.menuData, 1)[3]
                }else{
                    this.datacolumns.push({ field: "receptionno", label: 'Reception No' });
                    this.datacolumns.push({ field: "sampleid", label: 'Sample No' });
                    this.datacolumns.push({ field: "barcode", label: 'Barcode' });
                    headerColumns = common.menuHeader(mid, this.menuData, 1)[3]
                    detailColumns = common.menuHeader(mid, this.menuData, 2)[3]
                }
            }

            headerColumns.forEach((a,b) => {
                this.datacolumns.push({field: a.columnCode, label: a.columnName});
            });

            detailColumns.forEach((a,b) => {
                this.datacolumns.push({field: a.columnCode, label: a.columnName});
            });

            this.classifySampleData(mid);
        },

        async classifySampleData(thisMid) {
            this.isLoading = true;
            let row = [];
            let rs_data = [];
            let detailData = [];

            await this.$axios.get(this.$apiHost + "/demultis/step", {
                params: { rid: this.rid, stepid: thisMid, mid: this.properties.mid  }
            }).then(res => {
                detailData = res.data
            }).catch(err => {
                console.log(err);
            });
        
            this.items = detailData

            this.isLoading = false;
        },
            /* analysis tab pre data */
            async classifyAPreSampleData() {
                let rowNum = event.target.id.replace(/[0-9]/g, "");
                
				if(rowNum.length === 0){
					if(!common.isNull(event.target.id)){
						rowNum = event.target.id;
						this.aRowNum = rowNum;
					}else{
						rowNum = this.aRowNum;
					}
				}else{
					rowNum = this.aRowNum;
                }
                this.aPreSampleData = [];
                this.aPreSampleData = common.makeData(this.aPreDefaultSampleData[rowNum], 1, this.addData); // {data, (0: code, 1:name), checkdata}
                let receptionnoCode = ""
                this.preSampleHeader.some(a => {
                    if(a.hasOwnProperty("columnAttr")){
                        if(a.columnAttr == 'receptionno'){
                            receptionnoCode = a.field
                            return true;
                        }
                    }
                })
				for (let i in this.aPreSampleData) { //샘플탭 샘플 상세보기에 넘버링 값 추가
                    this.aPreSampleData[i].no = Number(i) + 1;
                    if(receptionnoCode == this.aPreSampleData[i].columnCode){
                        this.aPreSampleData[i].columnName = "<a href='#modal5' data-toggle='modal'>"+this.aPreSampleData[i].columnName+"</a>"
                    }
				}
				if(this.$refs.table.isRowChecked(this.$refs.table.visibleData[rowNum])){
					this.sampleCheckedRows = this.aPreSampleData;
				}else{
					this.sampleCheckedRows = [];
				}
				return false;
            },
			/*
			* Previous Group Header
			*/
			async classifyPreHeader(initial){
				let mid = common.preMid(this.properties.mid, this.menuData);
				this.preHeader = [];
                this.preHeader = common.menuHeader(mid, this.menuData)[3];
                for(let i in this.preHeader){
                    if(this.preHeader[i].columnName == 'No'){
                        this.preHeader.splice(this.preHeader[i].columnName.indexOf("No"), 1);
                    }    
                }
				this.classifyPreData(initial);
				return false;
			},
			/*
			* Previous Group Data
			*/
			async classifyPreData(initial){
				// this.preData = [];
				// this.preData = common.makeData_wait(this.preDefaultData, 1); // {data, (0: code, 1:name), checkdata}
                
                this.isLoading = true;
                let preMid = common.preMid(this.properties.mid, this.menuData);
                var params = []
                params = { mid: preMid };

                if (this.sortField) params["sortName"] = this.sortField;
                if (this.sortOrder) params["sortOrder"] = this.sortOrder;

                // input type
                for (let i in this.inputSearchForms) {
                    if (this.inputSearchForms[i].value) {
                        params[this.inputSearchForms[i].id] = this.inputSearchForms[i].value;
                    }
                }
                // // date type
                for (let i in this.dateSearchForms) {
                    if (this.dateSearchForms[i].fvalue || this.dateSearchForms[i].evalue) {
                        params[this.dateSearchForms[i].id] =this.dateSearchForms[i].fvalue +"," +this.dateSearchForms[i].evalue;
                    }
                }
                // check box type
                for (let i in this.checkboxSearchForms) {
                    let inputKey = this.checkboxSearchForms[i].id;
                    let checkValueStr = [];
                    for (let j in this.checkboxSearchForms[i].subs) {
                        let checkid = this.checkboxSearchForms[i].subs[j].codeCode;
                        if ($("#" + checkid).is(":checked")) {
                            checkValueStr[i] = checkValueStr.length > 0 ? checkValueStr[i].concat(",", $("#" + checkid).val()) : $("#" + checkid).val();
                        }
                    }
                    if (checkValueStr[i]) {
                        params[inputKey] = checkValueStr[i];
                    }
                }
                var request = { params: params };
                this.loading = true;
                await this.$axios.get(this.$apiHost + "/demultis" + "/search", request).then(res => {
                // api.themoviedb.org manage max 100 pages
                this.preData = [];
                let currentTotal = res.data.length;
                if (res.data.length / this.perPage > 100) {
                    currentTotal = this.perPage * 100;
                }
                this.total = currentTotal;
                for (let i in res.data) {
                    // res.data[i].no = res.data.length - Number(i);
                    this.preData.push(res.data[i]);
                }
                    this.loading = false;
                    this.isLoading = false;
                }).catch(error => {
                    this.data = [];
                    this.total = 0;
                    this.loading = false;
                    throw error;
                });

                this.createSearchForm(2, initial);
				return false;
			},
			/*
			* Previous Sample Header
			*/
			async classifyPreSampleHeader(form){
				var tempPreheader = [];
				let mid = '';
			
				if(common.isNull(form)){
					mid = common.preMid(this.properties.mid, this.menuData);
				}else{
					mid = form.id;
                }
                
                this.preSampleHeader = [];
                tempPreheader = common.makeHeader(common.preMid(this.properties.mid, this.menuData), this.menuData,2)[1];
                
                
				for(let i in tempPreheader){
                    // console.log(tempPreheader[i].columnAttr ,tempPreheader[i].columnName)
                    if(i == 0) this.preSampleHeader.push({'field': 'no', 'label':'No', 'centered':true})//샘플탭 샘플 상세보기에 넘버링 라벨 추가
					if(mid === tempPreheader[i].mid) {
                        this.preSampleHeader.push({'field':tempPreheader[i].columnCode, 'label':tempPreheader[i].columnName, 'centered':true});
                    }else{
                        if(tempPreheader[i].columnAttr == 'receptionno')this.preSampleHeader.push({'field':tempPreheader[i].columnCode, 'label':tempPreheader[i].columnName, 'centered':true,'columnAttr':tempPreheader[i].columnAttr, renderer: this.anchorRenderer})
                    }
					if(common.isNull(tempPreheader[i].mid)) this.preSampleHeader.push({'field':tempPreheader[i].columnCode, 'label':tempPreheader[i].columnName, 'centered':true});
                }
                

				this.classifyPreSampleData();
				return false;
			},
			/*
			*  analysis tab Previous Sample Header
			*/
			async classifyAPreSampleHeader(form){
				var tempPreheader = [];
				let mid = '';
			
				if(common.isNull(form)){
					mid = common.preMid(this.properties.mid, this.menuData);
				}else{
					mid = form.id;
                }
                
                this.preSampleHeader = [];
                tempPreheader = common.makeHeader(common.preMid(this.properties.mid, this.menuData), this.menuData,2)[1];
                
                
				for(let i in tempPreheader){
                    // console.log(tempPreheader[i].columnAttr ,tempPreheader[i].columnName)
                    if(i == 0) this.preSampleHeader.push({'field': 'no', 'label':'No', 'centered':true})//샘플탭 샘플 상세보기에 넘버링 라벨 추가
					if(mid === tempPreheader[i].mid) {
                        this.preSampleHeader.push({'field':tempPreheader[i].columnCode, 'label':tempPreheader[i].columnName, 'centered':true});
                    }else{
                        if(tempPreheader[i].columnAttr == 'receptionno')this.preSampleHeader.push({'field':tempPreheader[i].columnCode, 'label':tempPreheader[i].columnName, 'centered':true,'columnAttr':tempPreheader[i].columnAttr})
                    }
					if(common.isNull(tempPreheader[i].mid)) this.preSampleHeader.push({'field':tempPreheader[i].columnCode, 'label':tempPreheader[i].columnName, 'centered':true});
                }
                

				this.classifyAPreSampleData();
				return false;
			},
			/*
			* wait tab detail data
			*/
			async classifyPreSampleData(){
                let rowNum = event.target.id.replace(/[0-9]/g, "");
                
				if(rowNum.length === 0){
					if(!common.isNull(event.target.id)){
						rowNum = event.target.id;
						this.rowNum = rowNum;
					}else{
						rowNum = this.rowNum;
					}
				}else{
					rowNum = this.rowNum;
                }
                this.preDefaultSampleData = common.thisZeroDataSplice(this.preDefaultSampleData);
                
				this.preSampleData = [];
                this.preSampleData = common.makeData(this.preDefaultSampleData[rowNum], 1, this.addData); // {data, (0: code, 1:name), checkdata}
                let receptionnoCode = ""
                this.preSampleHeader.some(a => {
                    if(a.hasOwnProperty("columnAttr")){
                        if(a.columnAttr == 'receptionno'){
                            receptionnoCode = a.field
                            return true;
                        }
                    }
                })
                

				for (let i in this.preSampleData) { //샘플탭 샘플 상세보기에 넘버링 값 추가
                    this.preSampleData[i].no = Number(i) + 1;
                    if(receptionnoCode == this.preSampleData[i].columnCode){
                        this.preSampleData[i].columnName = "<a href='#modal5' data-toggle='modal'>"+this.preSampleData[i].columnName+"</a>"
                    }
				}
				if(this.$refs.table.isRowChecked(this.$refs.table.visibleData[rowNum])){
					this.sampleCheckedRows = this.preSampleData;
				}else{
					this.sampleCheckedRows = [];
				}

				return false;
			},
			/*
			* wait tab header data
			*/
			async classifyPreDefaultData(initial){
				this.preDefaultData = [];
				this.preSampleData = [];
				this.preDefaultSampleData = [];
				this.defaultOpenedDetails = [];

                let mid = this.properties.mid;
				
				var params = [];
                params = {'mid' : mid};
                // input type
				for (let i in this.inputSearchForms) {
					if (this.inputSearchForms[i].value) params[this.inputSearchForms[i].id] = this.inputSearchForms[i].value;
				}
				// // date type
				for (let i in this.dateSearchForms) {
					if (this.dateSearchForms[i].fvalue || this.dateSearchForms[i].evalue) {
						params[this.dateSearchForms[i].id] = this.dateSearchForms[i].fvalue +","+this.dateSearchForms[i].evalue;
					}
				}

				// check box type
				for (let i in this.checkboxSearchForms) {
					let inputKey = this.checkboxSearchForms[i].id;
					let checkValueStr = [];
					for (let j in this.checkboxSearchForms[i].subs) {
						let checkid = this.checkboxSearchForms[i].subs[j].codeCode;
						if ($("#" + checkid).is(":checked")) {
							checkValueStr[i] =
							checkValueStr.length > 0 ? checkValueStr[i].concat(",", $("#" + checkid).val()) : $("#" + checkid).val();
						}
					}
					if (checkValueStr[i]) params[inputKey] = checkValueStr[i];
				}
				
				// params = {'mid' : mid};
				var request = {params : params}
				await this.$axios.get(this.$apiHost + '/micro/step', request)
				.then(res=>{
					this.preDefaultData = [];
					this.preDefaultSampleData = [];
					for(let i in res.data){
                        // if(res.data[i].samples.length > 0){
							res.data[i].no = Number(i)+1;
							this.preDefaultData.push(res.data[i]);
								for(let j in res.data[i].samples){
									this.preDetail[res.data[i].samples[j].sampleId] = res.data[i].samples[j].duid;
									res.data[i].samples[j].gid = res.data[i].id;
								}
							this.preDefaultSampleData.push(res.data[i].samples);
                        // }
					}
                    
					let currentTotal = res.data.length;
					if (res.data.length / this.wPerPage > 100) {
						currentTotal = this.wPerPage * 100;
					}
					this.wTotal = currentTotal;
				}).catch(err=>{console.log(err)});
				this.preSetting(initial);
				return false;
            },
            /*
			* Analysis Group Header
			*/
			/*
			* First Load Previous Data & Samples Data
			*/
			// async classifySampleHeader(){
                
			// 	var tempPreheader = [];
            //     let mid = event.target.id;
            //     this.sampleHeader = [];
                

            //     if(common.isNull(mid)) mid = this.properties.mid

            //     tempPreheader = common.makeHeader(common.preMid(this.properties.mid, this.menuData), this.menuData,2)[1];
            //     let tempHeader = common.makeHeader(mid,this.menuData,2)[1];
                
                
            
            //     // column data matching
			// 	for(let i in tempHeader){
            //         if(i == 0) this.sampleHeader.push({'field': 'no', 'label':'No', 'centered':true})//샘플탭 샘플 상세보기에 넘버링 라벨 추가
			// 		if(mid === tempHeader[i].mid) {
            //             if(tempHeader[i].columnAttr == 'serial'){
            //                 this.sampleHeader.push({'field':'serial', 'label':tempHeader[i].columnName, 'centered':true,'columnAttr':tempHeader[i].columnAttr})
            //             }else if(tempHeader[i].columnAttr == 'task'){
            //                 this.sampleHeader.push({'field':'task', 'label':tempHeader[i].columnName, 'centered':true,'columnAttr':tempHeader[i].columnAttr})
            //             }else{
            //                 this.sampleHeader.push({'field':tempHeader[i].columnCode, 'label':tempHeader[i].columnName, 'centered':true});
            //             }
            //         }else{
            //             if(tempHeader[i].columnAttr == 'receptionno')this.sampleHeader.push({'field':tempHeader[i].columnCode, 'label':tempHeader[i].columnName, 'centered':true,'columnAttr':tempHeader[i].columnAttr})
            //         }
                    
			// 		if(common.isNull(tempHeader[i].mid)) this.sampleHeader.push({'field':tempHeader[i].columnCode, 'label':tempHeader[i].columnName, 'centered':true});
			// 	}

			// 	return false;
			// },
			/*
			* Sample Add Column
			*/
			async addRun(){
                if(this.waitCheckedRows.length  > 1){
                    this.$buefy.dialog.alert({
                        message: 'You Cannot Select more than one Run Id.',
                        size: 'is-small',
                    })
                }else if(this.waitCheckedRows.length == 0){
                    this.$buefy.dialog.alert({
                        message: 'Please Select Run Id.',
                        size: 'is-small',
                    })
                }else if(this.selPipeline.length == 0){
                    this.$buefy.dialog.alert({
                        message: 'Please Select Pipeline.',
                        size: 'is-small',
                    })
                }else{
                    this.$buefy.dialog.confirm({
                        message: 'Do you want to analyzing ?',
                        size: 'is-small',
                        onConfirm: async () => {
                            let checkedArr = [];
							let param = [];
							if (this.selPipeline.fileExtension === 'python') {
								this.dialog = false;

								if (this.database) {
									param.push({key:'DB', value: this.database})
								}
								if (this.identity) {
									param.push({key:'REF_IDENTITY', value: this.identity})
								}
								if (this.trim_fwd) {
									param.push({key:'TRIM_FWD', value: this.trim_fwd})
								}
								if (this.trim_rev) {
									param.push({key:'TRIM_REV', value: this.trim_rev})
								}
								if (this.trim_merged) {
									param.push({key:'TRIM_MERGED', value: this.trim_merged})
								}
								if (this.read_depth) {
									param.push({key:'READ_DEPTH', value: this.read_depth})
								}
								
								if (this.method) {
									param.push({key:'METHOD', value: this.method})
								}
							} else {
								this.dialogShell = false;

								if (this.database) {
									param.push({key:'DB', value: this.database})
								}
								if (this.min_depth) {
									param.push({key:'MIN_DEPTH', value: this.min_depth})
								}
								if (this.max_depth) {
									param.push({key:'MAX_DEPTH', value: this.max_depth})
								}
								if (this.group) {
									param.push({key:'GROUP', value: this.group})
								}
								if (this.region) {
									param.push({key:'REGION', value: this.region})
								}
								if (this.type) {
									param.push({key:'TYPE', value: this.type})
								}
								if (this.remove_mt) {
									param.push({key:'REMOVE_MT_CP', value: this.remove_mt})
								}
							}

						
							let pipeline = {
								companyId: this.selPipeline.companyId,
								createDate: this.selPipeline.createDate,
								creator: this.selPipeline.creator,
								id: this.selPipeline.id,
								name: this.selPipeline.name,
								outPutDir: this.selPipeline.outPutDir,
								pipelineNo: this.selPipeline.pipelineNo,
								reportDataFile: this.selPipeline.reportDataFile,
								reporterFile: this.selPipeline.reporterFile,
								resultMenu: this.selPipeline.resultMenu,
								runFile: this.selPipeline.runFile,
								sheetId: this.selPipeline.sheetId,
								type: this.selPipeline.type,
								updateDate: this.selPipeline.updateDate,
								usedCode: this.selPipeline.usedCode,
								version: this.selPipeline.version,
								remoteHost: this.selPipeline.remoteHost,
								remoteUserName: this.selPipeline.remoteUserName,
								fileExtension: this.selPipeline.fileExtension,
								param,
							}

                            for (let i in this.waitCheckedRows) {
                                let run = {
                                    pipeline,
                                    id : this.waitCheckedRows[i].id,
                                    runId : this.waitCheckedRows[i].runId,  
									mid : this.properties.mid,
									serial: this.serial,
									path: this.inputPath,
									reFlag: false,
                                }
                                checkedArr.push(run)
                            }
							
                            await this.$axios.post(this.$apiHost + "/"+this.$route.name+"/task",checkedArr[0]).then(res=>{
                                 if(res.data.message == 'OK'){
                                    this.$buefy.dialog.alert({
                                        message: 'Added Task.',
                                        size: 'is-small',
                                        onConfirm : async() => {
											this.dialog = false;
											this.dialogShell = false;
                                            this.$router.go({name:this.$route.name});
                                        }
                                    })                                    
                                }
                            }).catch(err=>{
                                if(err.response.data.message == 'DUPLE'){
                                    this.$buefy.dialog.alert({
                                        message: 'serial already exist.',
                                        size: 'is-small',
                                    })
                                }else if (err.response.data.message == 'QUEUE'){
                                    this.$buefy.dialog.confirm({
                                        message: 'Analysis task is already in progress. Would you like to add it to the queue?',
                                        size: 'is-small',
                                        onConfirm: async () => {
                                            let checkedArr = [];
                                            for(let i in this.waitCheckedRows){
                                                let run = {
                                                    pipeline : this.selPipeline,
                                                    id : this.waitCheckedRows[i].id,
                                                    runId : this.waitCheckedRows[i].runId,  
                                                    mid : this.properties.mid,
                                                    serial: this.waitCheckedRows[i].serial,
                                                    path: this.waitCheckedRows[i].path,
                                                    reFlag: false,
                                                }
                                                checkedArr.push(run)
                                            }
                                            await this.$axios.post(this.$apiHost + "/"+this.$route.name+"/queue",checkedArr[0]).then(res=>{
                                                if(res.data.message == 'OK'){
                                                    this.$buefy.dialog.alert({
                                                        message: 'Added in Queue.',
                                                        size: 'is-small',
                                                        onConfirm : async() => {
                                                            this.$router.go({name:this.$route.name});
                                                        }
                                                    })                                    
                                                }
                                            }).catch(err=>{
                                                
                                            });
                                        }
                                    })
                                }else{
                                    console.log(err.response)
                                    this.$buefy.dialog.alert({
                                        message: 'Please Check out Daemon Server. .',
                                        size: 'is-small',
                                    })
                                }
                            });
                        }
                    })
				}
				return false;
            },
			runDialogHandler() {
				if (this.selPipeline.id && this.waitCheckedRows.length == 1) {
					if (this.selPipeline.fileExtension === 'python') {
						this.serial = this.waitCheckedRows[0].runId;
						this.inputPath = this.waitCheckedRows[0].path;
						this.database = '';
						this.identity = '';
						this.trim_fwd = '';
						this.trim_rev = '';
						this.trim_merged = '';
						this.read_depth = '';
						this.method = '';

						this.min_depth = '0';
						this.max_depth = '0';
						this.group = '';
						this.region = '';
						this.type = 'paired';
						this.remove_mt = 'N';

						for (let i of this.selPipeline.param) {
							if (i.key == 'TRIM_FWD') {
								this.trim_fwd = i.value;
							} else if (i.key == 'TRIM_REV') {
								this.trim_rev = i.value;
							} else if (i.key == 'TRIM_MERGED') {
								this.trim_merged = i.value;
							} else if (i.key == 'READ_DEPTH') {
								this.read_depth = i.value;
							} else if (i.key == 'REF_IDENTITY') {
								this.identity = i.value;
							} else if (i.key == 'DB') {
								this.database = i.value;
							} else if (i.key == 'METHOD') {
								this.method = i.value;
							}
						}
						this.dialog = true;
					} else {
						// serial, inputPath, min_depth, max_depth, group, region, database, type
						this.serial = this.waitCheckedRows[0].runId;
						this.inputPath = this.waitCheckedRows[0].path;
						this.min_depth = '0';
						this.max_depth = '0';
						this.group = '';
						this.region = '';
						this.database = '';
						this.type = 'paired';
						this.remove_mt = 'N';
						
						this.identity = '';
						this.trim_fwd = '';
						this.trim_rev = '';
						this.trim_merged = '';
						this.read_depth = '';
						this.method = '';

						for (let i of this.selPipeline.param) {
							if (i.key == 'DB') {
								this.database = i.value;
							} else if (i.key === 'MIN_DEPTH') {
								this.min_depth = i.value;
							} else if (i.key === 'MAX_DEPTH') {
								this.max_depth = i.value;
							} else if (i.key === 'GROUP') {
								this.group = i.value;
							} else if (i.key === 'REGION') {
								this.region = i.value;
							} else if (i.key === 'TYPE') {
								this.type = i.value;
							}
						}

						this.dialogShell = true;
					}

				} else {
					  this.$buefy.dialog.alert({
                        message: 'Please select a pipeline and sample',
                        size: 'is-small',
                    })
				}
			},
			zoomOut () {
				this.read_depth = (this.read_depth - 1000) || 1000
			},
			zoomIn () {
				this.read_depth = (this.read_depth + 1000) || 100000
			},
			/*
			* Sample Delete Column
			*/
			async sampleDelColumn(){

			},
			/*
			* Experiment Data Check All
			*/
			async checkAll(){
				const checkRow = this.$refs.sheet.hotInstance.getData();
				if(this.isCheckAll){
					this.isCheckAll = false;
				}else{
					this.isCheckAll = true;
				}
				this.sampleData.forEach(a => {
					a[0] = this.isCheckAll;
				});
				this.rendertab();
				return false;
			},
			/*
			* Experiment Data Change Arrary Insert
			*/
			async changeData(source){
				if(this.$refs.sheet.hotInstance){
					this.sampleChangeData = this.$refs.sheet.hotInstance.getData();
				}
				if(arguments[1] === 'edit' || arguments[1] === 'Autofill.fill'){ //문제 없음
					//arguments[0][0][3] => 입력값 arguments[0][0][0] => rownum
                    if(arguments[0][0][3] != arguments[0][0][0]){ //DNA에서는 일로 탐
                        this.boolChange = true;
                    }else{
                        if (Number(arguments[0][0][1]) > 2) {
                            if (this.defaultSampleData) {
                                if(arguments[0][0][3] != this.defaultSampleData[arguments[0][0][0]][Number(arguments[0][0][1])-1]){
                                    this.boolChange = true;
                                }else{
                                    this.boolChange = false;
                                }
                            } else {
                                this.boolChange = true;
                            }
						} else {
							 this.boolChange = true;
						}
						
					}
                } else if (arguments[1] === 'loadData') { //sample add 후 아무 동작 안하고 save할시에 
					if (this.sampleChangeData) {
						if (arguments[0]) {
							this.boolChange = true;
						} else {
							this.boolChange = false;
						}
					}
				}

				if(this.isWork > 0) this.boolChange = true;
				return false;
            },
         /*
         * Experiment & Samples Create data
         */
         async createData(){
            this.openLoading();
            var params = [];
            var sendKey = '';
            var sendValue = '';
            var changeData = [];
            var thisData = [];
			let wellList = [];
			let last_plate = common.find_last_column(this.sampleHeader,'plate');
            var sidx = 0;	
			var myNum = 2
            for(let i=0; i<this.well_column; i++){
               for(let j=0; j<this.well_row; j++){
               let list = document.getElementById('list'+(Number(j)+1));
                  if(list.childNodes[i].innerText.length > 4){
                     wellList.push([list.childNodes[i].innerText,this.well_row_a[j],(Number(i)+1)]);
                  }
               }
			}
            for(let i in this.sampleData){
               
				for(let j in this.sampleData[i]){
					if(j == 2){
						// set sample : detail id 
						changeData.sid = this.sampleData[i][j];
					}
					if(j > 2){
						if (common.isNull(this.sampleHeader[Number(j-3)])) {
							changeData.detailId = this.sampleData[i][j];
						} else {
							changeData[this.sampleHeader[Number(j-3)].columnCode] = this.sampleData[i][j];

							if(this.sampleHeader[Number(j-3)].columnAttr === 'divisionidx'){
							sidx = j;
							let divIdx = 0;
							divIdx = this.sampleData[i][j];
							changeData.divIdx = divIdx;
							}

							if(this.sampleHeader[Number(j-3)].columnAttr === 'reexpidx'){
								sidx = j;
								let reIdx = 0;
								reIdx = this.sampleData[i][j];
								changeData.reIdx = reIdx;
							}

								if(this.sampleHeader[Number(j-3)].columnAttr === 'plate'){ //changeData의 위치정보 확인
									if(last_plate === this.sampleHeader[Number(j-3)].columnCode) {
										for(let k in wellList){
											let sampleId = this.sampleData[i][Number(common.find_sid_idx(this.sampleHeader, 'sampleid'))+3];
											if (wellList[k][0].length > 13) {
												sampleId = sampleId + wellList[k][0].substr(13)
											}
											if(wellList[k][0] === sampleId){
												changeData[this.sampleHeader[Number(j-3)].columnCode] = [wellList[k][1],wellList[k][2]];
												wellList.splice(k,1);
												break;
											}
										}
									}
								}
							}
						} 
					}
					thisData.push($.extend(true, {}, changeData));
					changeData = [];
				}
				params = { 
					'msid': this.msid,
					'uid': this.properties.uid,
					'ssid': this.ssid,
                    'samples': thisData,
                    'preStatus' : common.preStatus(this.properties.mid,this.menuData),
                    'preStatusA' : common.preStatus(this.properties.mid,this.menuData)
				}
				for(let i in this.experimentHeader){
					sendKey = this.experimentHeader[i].columnCode;
					sendValue = this.experimentData[this.experimentHeader[i].columnCode];
					if(this.experimentData[this.experimentHeader[i].columnCode] != this.defaultExperimentData[this.experimentHeader[i].columnCode]){
						this.boolChange = true;
					}
					if(sendValue){
						params[sendKey] = sendValue
					}
				}
				// 데이터 변경이 있는 경우에만 저장
				if(this.boolChange){
					this.$axios.post(this.$apiHost+'/'+this.$route.name.substring(0, this.$route.name.indexOf('_')), params)
					.then(res=>{
						sessionStorage.setItem('uid',res.data.uid);
						this.properties.uid = res.data.uid;
					
						this.uploadFlag = true;
						this.upload();
						this.isLoading = false;
						this.$router.go({name:this.$route.name});
						return false;
					})
					.catch(err=>{
						if(err){
							alert('The system failed and the save failed. Please contact your system administrator.');
						}						
						console.log(err)});
				}else{
					this.isLoading = false;
					alert('No data has been changed. Can not save.');
					return false;
				}
			},
			async deleteData() {
				let result = confirm('Are you sure you want to delete it?');
				if (result) {
					const colCnt = this.$refs.sheet.hotInstance.countRows();
					const deleteArr = [];
					const delData = [];
					let params = [];
					for(let i=0; i < Number(colCnt); i++){
						deleteArr[i] = this.$refs.sheet.hotInstance.getData(i,Number(this.$refs.sheet.hotInstance.countCols())-1,i,0)[0];
					}
					for (let i in deleteArr) {
						let del = {
							'sampleId'	: deleteArr[i][2],
							'detailId'	: deleteArr[i][Number(this.$refs.sheet.settings.columns.length)-1],
							'division'	: deleteArr[i][Number(common.find_sid_idx(this.sampleHeader, 'divisionidx'))+3],
							'reexp'		: deleteArr[i][Number(common.find_sid_idx(this.sampleHeader, 'reexpidx'))+3]
						}
						delData.push(del);
					}

					params = {'delData':delData, 'hId':this.properties.uid};
					this.$axios.patch(this.$apiHost+'/'+this.$route.name.substring(0, this.$route.name.indexOf('_'))+'/delete', params)
					.then(res=>{
						if (res.data) {
							this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.properties.mid, type:'list'}});
						}
						return false;
					})
				} else {
					this.isLoading = false;
					return false;
				}
			},
			/*
			* List page Move (리스트 목록 페이지 이동)
			*/
			goPage() {
				if(this.boolChange){
				var result = confirm('You have changed data. Would you like to leave?');
				if(result){
					sessionStorage.removeItem('uid');
					this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.properties.mid, type:'list'}});
				}else{
					return false;
				}
				}else{
					this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.properties.mid, type:'list'}});
				}
			},
			/*
			* buefy 테이블 현재 토글 디테일 창 열기
			*/
			toggle(row) {
                // 본인 토글 창이 열려있을때 창 닫기.. b-table 설정에 defaultOpenedDetails 배열은 현재 열린 창이 입력 되도록 되어 있음
				if(row.id === this.defaultOpenedDetails[0]){
				this.defaultOpenedDetails = []
				}else{ // 토글 창이 닫혀있을때 실행
				this.$refs.table.toggleDetails(row);
				this.defaultOpenedDetails = [row.id]
				}
				this.preSampleSetting();
			},
			/*
			* buefy 테이블 현재 토글 디테일 창 열기
			*/
			aToggle(row) {
                // 본인 토글 창이 열려있을때 창 닫기.. b-table 설정에 defaultOpenedDetails 배열은 현재 열린 창이 입력 되도록 되어 있음
				if(row.id === this.defaultOpenedDetails[0]){
				this.defaultOpenedDetails = []
				}else{ // 토글 창이 닫혀있을때 실행
				this.$refs.table.toggleDetails(row);
				this.defaultOpenedDetails = [row.id]
				}
				this.aPreSampleSetting();
			},
			/*
			* buefy 테이블 이전 토글 디테일 창 닫기 b-table 설정에 toggle 창 실행 시 이전 창은 닫히고 현재 선택 창이 열리도록 설정 되어 있음
			*/
			closeAllOtherToggle(row, index) {
				this.defaultOpenedDetails = []
				this.defaultOpenedDetails = [row.id]
			},
			/*
			* handsontable 문제가 있음 화면에 정상 랜더링이 아니면 화면이 나타나지 않음 그래서 setTimeout으로 2번 실행하여 랜더링 위치 잡는 함수
			*/
			rendertab() {
				// // height 는 Hansontable이 height를 설정하지 않으면 Handsontable event 가 일어날때마다 계속 height가 무한정 늘어남
				// // hotInstance의 updateSettings를 사용하여 기본 setting 값을 수정 한다.
				// if(this.sampleData.length > 0){

				// // plate 위치 변경 확인
				// let last_plate_idx = common.find_last_column_idx(this.sampleHeader, 'plate'); // 마지막 plate 위치 확인
				// let plate_chg = common.plateDataChange(Number(last_plate_idx)+3, this.sampleData);
				// plate_chg.forEach((a)=>{
				// 	this.sampleData[a[0]][Number(last_plate_idx)+3] = a[1]
				// });
				// // handsontable render 기본 높이 구하기
				// let height = (((this.$refs.sheet.hotInstance.countRows()) * 34)+50)+'px';
				// this.$refs.sheet.hotInstance.updateSettings({height:height})
				// // Handsontable 문제로 화면이 전환될때 기존에 출력 화면 위치를 잃어 버림, render를 한번 사용하면 화면에 출력될 디자인만 그린다
				// // 출력 위치까지 잡으려면 render를 한번 더 사용해야한다. 연속으로 render를 하면 되지 않아서 setTimeout으로 약간의 시간차를 두고 render 실행한다
				// // 하지만 tab를 사용할 때 데이터가 있다면 4줄정도만 나오게 된다. 이부분 때문에 동일한 render를 무려 8번이나 실행했다.
				// // 그렇다고 setTimeout의 시간을 늘려 render 시간을 해주는건 헛수고 이다.
				// // 짧은 시간 반복 횟수가 중요 함 (10*20 timeout이 가장 적절하며, 20이하는 render 안됨)
				// setTimeout(() => {this.$refs.sheet.hotInstance.render();}, 10 * 20)
				// this.$refs.sheet.hotInstance.render();
				// setTimeout(() => {this.$refs.sheet.hotInstance.render();}, 10 * 20)
				// this.$refs.sheet.hotInstance.render();
				// setTimeout(() => {this.$refs.sheet.hotInstance.render();}, 10 * 20)
				// this.$refs.sheet.hotInstance.render();
				// setTimeout(() => {this.$refs.sheet.hotInstance.render();}, 10 * 20)
				// this.$refs.sheet.hotInstance.render();
				// }else{
				// setTimeout(() => {this.$refs.sheet.hotInstance.render();}, 10 * 20)
				// this.$refs.sheet.hotInstance.render();
				// }
			},

			/*
			* confirm Data page Move
			*/
			async confirmData() {
				if (this.properties.uid) {
					this.openLoading();
					var result = confirm('Are you sure you want to confirm?');
					const uid = this.properties.uid;
					const mid = this.properties.mid
					let colCnt = this.$refs.sheet.hotInstance.countRows();
					let detailIds = [];
					for(let i=0; i < Number(colCnt); i++){
						detailIds.push(this.$refs.sheet.hotInstance.getDataAtCell(i,this.sampleData[i].length-1));
					}
					
					if (result) {
						this.$axios.patch(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/confirm', {
						uid, detailIds,mid
						})
						.then((res) => {
							sessionStorage.setItem('uid',uid);
							this.isLoading = false;
							this.$router.push({name:'experiments_completion',params:{mid:this.properties.mid,uid:uid,type:'detail'}});
						});
					} else {
						this.isLoading = false;
						return false;
					}
				}
			},
			/*
			* Handle page-change event
			*/
			onPageChange(page) {
				if (this.tabFlag == 2) {
					this.wPage = page;
					this.classifyPreDefaultData(false);
				} else {
					this.page = page;
					this.classifyData(this.tabFlag, false);
				}
				return false;
			},
			 /*
			* Handsontable Reception no cell render
			*/
			anchorRenderer(instance, td, row, col, prop, value, cellProperties) {
				Handsontable.renderers.TextRenderer.apply(this, arguments);
				let anchor = null;
				anchor = document.createElement("a");
				anchor.href='#modal34'
				anchor.setAttribute("data-toggle","modal");
				anchor.text = value;
				const sendId = this.sendId;
				const sampleData = this.experimentData.samples;
				anchor.onclick = function() {
					sendId(sampleData[row].id);
				};
				Handsontable.dom.empty(td);
				td.appendChild(anchor);
			},

			/*
			* confirm Data page Move
			*/
			// async classifyWorkChange(mid) {
			// 	this.re_expid = mid;
			// 	this.classifyPreDefaultData();
		 	// },

			/*
			* page Loading bar
			*/
			openLoading() {
				this.isLoading = true
				setTimeout(() => {
					this.isLoading = false
				}, 10 * 100)
			},
			preSetting(initial) {
				return this.classifyPreHeader(initial);
			},
		},
		computed: {
			sheetSettings() {
				let settings = this.$store.getters.sheetSettings;
				return settings;
			},
			preSampleSetting() {
				return this.classifyPreSampleHeader;
			},
			aPreSampleSetting() {
				return this.classifyAPreSampleHeader;
			},
			// targetRegion2Options: function () {
			// 	return this.targetRegion1 === '16S' ? ['V4', 'V3V4'] : 
			// 		this.targetRegion1 === '18S' ? ['V3V4', 'V9'] : 
			// 		this.targetRegion1 === 'ITS' ? ['ITS1', 'ITS2'] : []
			// },
			// databaseOptions: function () {
			// 	return this.targetRegion1 === '16S' ? ['Silva r132', 'Greengenes 13_5'] : 
			// 		this.targetRegion1 === '18S' ? ['Silva r132', 'Greengenes 13_5'] : 
			// 		this.targetRegion1 === 'ITS' ? ['UNITE ver 8.3'] : []
			// },
			// trim_fwd: {
			// 	get() {
			// 		return this.targetRegion2 === '' ? '0' : 
			// 			this.targetRegion2 === 'V4' ? '200' : '250'
			// 	},
			// 	set(val) {
			// 		this.targetRegion2 = val;
			// 	},
			// },
			// trim_rev: {
			// 	get() {
			// 		return this.targetRegion2 === '' ? '0' : 
			// 			this.targetRegion2 === 'V4' ? '200' : '250'
			// 	},
			// 	set(val) {
			// 		this.targetRegion2 = val;
			// 	},
			// },
			// trim_merged: {
			// 	get() {
			// 		return this.targetRegion2 === 'V4' ? '200' : '0'
			// 	},
			// 	set(val) {
			// 		this.targetRegion2 = val;
			// 	},
			// },
			
			
		},
		watch: {
			checkedRows: function() {
				// 상위 테이블 선택 한경우 this.checkedRowData에 무조건 Insert
				const validVisibleData = this.$refs.table.visibleData.filter((row, idx) => {
					if(this.$refs.table.isRowChecked(row)){
						this.checkedRowData = this.checkedRowData.concat(common.makeData(this.preDefaultSampleData[idx], 1, this.addData));
						common.a_overlap_c(this.checkedRowData);
					}else{
						let data = common.makeData(this.preDefaultSampleData[idx], 1, this.addData);
						data = data.filter((s_row, s_idx)=>{
							for(let i in this.checkedRowData){
								if(this.checkedRowData[i].hasOwnProperty('detailId') && s_row.hasOwnProperty('detailId')){
									if(this.checkedRowData[i].detailId === s_row.detailId){
										this.checkedRowData.splice(i, 1);
									}
								}else{
									if(this.checkedRowData[i].sampleId === s_row.sampleId){
										this.checkedRowData.splice(i, 1);
									}
								}

							}
						});
					}
				});
				// 하위 테이블 데이터 새로 고침
				this.classifyPreSampleData();
			},
			sampleCheckedRows: function(){
				// 하위 데이터가 모조건 전체 선택인 경우 실행 (현재 기준 19.08.29 15시)
				for(let i in this.$refs.table.visibleData){ 
					// 하위 sample 데이터의 갯수에 따른 상위 데이터 체크 박스 해제 기능
					if(this.$refs.table.isRowChecked(this.$refs.table.visibleData[i])){ // 상위 테이블 체크 여부 확인
						if(this.preSampleData.length > this.sampleCheckedRows.length){ // sample 데이터와 sample 체크 데이터 비교 조건
							for(let i in this.$refs.table.newCheckedRows){ // 상위 체크 데이터 loop
								if(this.preSampleData[0].gid === this.$refs.table.newCheckedRows[i].id){ // sample 데이터의 gid와 상위 체크 데이터 같은 경우 상위 데이터 splice
									this.$refs.table.newCheckedRows.splice(i, 1);
								}
							}
						}
					}
					// 하위 테이블 체크 박스 모두 선택 인 경우 상위 테이블의 체크 박스 추가 기능
					if(event.path[7].id === 'preSampleTable'){ // 하위 체크 박스 선택 여부 확인 (event로 구분했음 향후 변경 필요 함)
						if(this.$refs.sampleTable.isAllChecked){ // 하위 테이블의 체크 박스 전체 선택 여부 확인
							if(this.preSampleData[0].gid === this.$refs.table.visibleData[i].id){ // sample 데이터와 sample 체크 데이터 비교 조건
								this.$refs.table.newCheckedRows.push(this.$refs.table.visibleData[i]); // 없는 경우 추가
							}
						}
					}
				}
				// Add 데이터 생성
				this.checkedRowData = this.checkedRowData.concat(this.sampleCheckedRows); // 전체 넣기
				common.a_overlap_c(this.checkedRowData); // 중복 제거 common make function
				if(this.sampleCheckedRows.length != this.preSampleData.length){ // 전체 아닌 경우 Add 데이터 생성
					if(event.path[7].id === 'preSampleTable'){ // preSampleTable의 이벤트를 체크 (단 event의 path값 변경되면 수정 해주어야 함)
						let checkedIdx = [];
						this.checkedRowData  = this.checkedRowData.filter((a, b)=>{ // for 문 대신 filter로 구분 for 문이랑 같은 기능 reduce 도 있음
							this.preSampleData = this.preSampleData.filter((c, d)=>{ // checkRowData 와 preSampleData 의 sampleId를 비교
								// detailId key가 없는 경우 비교
								if(a.hasOwnProperty('detailId') && c.hasOwnProperty('detailId')){
									if(a.detailId === c.detailId){
										if(!this.$refs.sampleTable.isRowChecked(c)){ // row의 check box 가 true false 구분
											checkedIdx.push(b); // 함수 내 checkedIdx 변수에 위치 값 push (이유는 아래에..)
										}
									}
								}else{
									if(a.sampleId === c.sampleId){
										if(!this.$refs.sampleTable.isRowChecked(c)){ // row의 check box 가 true false 구분
											checkedIdx.push(b); // 함수 내 checkedIdx 변수에 위치 값 push (이유는 아래에..)
										}
									}
								}
								return this.preSampleData; // 이 값은 변경 하는것이 아니므로 그대로 return
							});
							return this.checkedRowData; // 이 값은 변경 하는것이 아니므로 그대로 return
						});
						checkedIdx.sort((a,b)=>{return b - a}) // 해당 변수를 역순으로 sort
						if(checkedIdx.length > 0){ // 이부분이 중요. 아래 조건문의 splice 는 해당 배열 값을 삭제 한다. 단 순차적으로 삭제하면 삭제한 row가 없어져 에러가 난다 (아래 계속)
							for(let i in checkedIdx){ // (아래 계속) 그래서 역순으로 정렬하여 배열의 마지막 값 부터 삭제 한다. 간단하지만 꼭 기억해야함.
								this.checkedRowData.splice(checkedIdx[i], 1);
							}
						}
					}
				}
				// // 개별 선택 체크 박스를 true로 바꾸는 작업
				if(this.sampleCheckedRows.length === 0 && this.checkedRowData.length > 0){
					this.checkedRowData  = this.checkedRowData.filter((a, b)=>{ // for 문 대신 filter로 구분 for 문이랑 같은 기능 reduce 도 있음
						this.preSampleData = this.preSampleData.filter((c, d)=>{ // checkRowData 와 preSampleData 의 sampleId를 비교
							if(a.hasOwnProperty('detailId') && c.hasOwnProperty('detailId')){
								if(a.detailId === c.detailId){
									this.sampleCheckedRows.push(c);
								}
							}else{
								if(a.sampleId === c.sampleId){
									this.sampleCheckedRows.push(c);
								}
							}
							return this.preSampleData; // 이 값은 변경 하는것이 아니므로 그대로 return
						});
						return this.checkedRowData; // 이 값은 변경 하는것이 아니므로 그대로 return..
					});
				}
			},
			preHeader: function(){
			},
		},
	}

</script>
<style src="../../../../node_modules/handsontable/dist/handsontable.full.css"></style>


// WEBPACK FOOTER //
// src/views/Analysis/Microbiome/List2.vue